import { BadgeCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { aboutRebecca } from "@/data/eventOrganizerContent";

const AboutRebeccaSection = () => {
  return (
    <section id="about-rebecca" data-testid="about-rebecca-section" className="space-y-10 py-24">
      <div className="max-w-4xl space-y-4">
        <p
          data-testid="about-rebecca-eyebrow-text"
          className="inline-flex items-center gap-2 rounded-full border border-fuchsia-200 bg-fuchsia-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-fuchsia-700"
        >
          <BadgeCheck className="h-3.5 w-3.5" />
          About Rebecca
        </p>
        <h2 data-testid="about-rebecca-heading" className="text-3xl leading-tight text-violet-950 md:text-5xl">
          {aboutRebecca.name}
        </h2>
        <p data-testid="about-rebecca-role" className="text-sm font-semibold uppercase tracking-[0.12em] text-fuchsia-700 md:text-base">
          {aboutRebecca.role}
        </p>
      </div>

      <Card data-testid="about-rebecca-card" className="border-fuchsia-200 bg-violet-50/75">
        <CardContent className="space-y-5 p-7">
          <p data-testid="about-rebecca-summary" className="text-base leading-relaxed text-violet-900/90">
            {aboutRebecca.summary}
          </p>
          <ul className="grid gap-3">
            {aboutRebecca.points.map((point, index) => (
              <li
                key={point}
                data-testid={`about-rebecca-point-${index + 1}`}
                className="rounded-lg border border-fuchsia-200 bg-fuchsia-100/65 px-4 py-3 text-sm leading-relaxed text-violet-900 md:text-base"
              >
                {point}
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </section>
  );
};

export default AboutRebeccaSection;